module.exports = __webpack_public_path__ + "img/13.0a328d2b.png";